// #1750 — the class grid is keyboard-first (design doc section 6): the judge
// calls rider numbers in whatever order they see them, so a scribe types and
// walks cells constantly. Native Tab order already advances left-to-right,
// row-by-row across `[data-grid-cell]` inputs (DOM order matches visual
// order), so this only needs to make Enter behave like Tab instead of
// submitting/doing nothing.
export function focusNextGridCell(e) {
  if (e.key !== "Enter") return;
  e.preventDefault();
  const cells = Array.from(document.querySelectorAll('[data-grid-cell="true"]'));
  const idx = cells.indexOf(e.target);
  if (idx >= 0 && idx < cells.length - 1) {
    cells[idx + 1].focus();
  }
}

// Numeric-aware rider-number sort. Ride.competitorNumber is z.string()
// (validation.js) so a naive string sort would put "10" before "2" — parse
// both as int and fall back to string compare when either side isn't
// numeric (blank/unassigned numbers still sort deterministically).
export function sortByCompetitorNumber(rides) {
  return [...rides].sort((a, b) => {
    const an = parseInt(a.competitorNumber, 10);
    const bn = parseInt(b.competitorNumber, 10);
    const aValid = !Number.isNaN(an);
    const bValid = !Number.isNaN(bn);
    if (aValid && bValid && an !== bn) return an - bn;
    if (aValid !== bValid) return aValid ? -1 : 1;
    return String(a.competitorNumber ?? "").localeCompare(String(b.competitorNumber ?? ""));
  });
}
